export default __webpack_public_path__ + "static/es-ga-23a30d01d4c6338e7f5c307f5045cfd6.svg";